/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */

import './Accordion/Accordion';
import './Buttons/stopDisabledLinksFiring';
import './Tables/TableWrapper';
import Video from './Video/Video';
import Dropdown from './Dropdown/Dropdown';
import Tooltip from './Tooltip/Tooltip';
import ComponentInit from '../js/utils/ComponentInit';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { Video, Dropdown, Tooltip };

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default ComponentInit(componentList);
